import { useEffect, useState } from "react";
import { CardTitle } from "reactstrap";
import { Loader, Switch, ToastService, Tooltip } from "@launchmetrics/lm-ui";
import BssoPermissions from "components/LM/Bsso/Permissions";
import K2Api from 'lib/ajax/K2Api';
import './InstagramStoryCrawlingSwitch.scss';

const K2_API = new K2Api();

function InstagramStoryCrawlingSwitch({ profileId }) {
	const [enabled, setEnabled] = useState(false);
	const [loading, setLoading] = useState(true);

	const statusUrl = `/socialmedia/instagram/storiescrawling/${profileId}`;

	useEffect(() => {
		let cancelled = false;
		setLoading(true);
		K2_API.get(statusUrl)
			.then(() => {
				if (!cancelled) {
					setEnabled(true);
				}
			})
			.catch(err => {
				if (!cancelled) {
					if (err.response?.status === 404) {
						setEnabled(false);
					} else {
						ToastService.show({
							id: "read-stories-crawling-failed",
							title: "Failed to read the Instagram Stories crawling state",
							type: "error",
						});
					}
				}
			})
			.finally(() => {
				if (!cancelled) {
					setLoading(false);
				}
			});
		return () => {
			cancelled = true;
		};
	}, [statusUrl]);

	return (
		<BssoPermissions permissions={['voices', 'edit']}>
			<CardTitle tag="h5" className="mt-3">Stories Detail</CardTitle>
			<div className="stories-crawling-switch">
				<Tooltip content="This status cannot be changed." placement="top">
					<span className="d-inline-block">
						<Switch
							className="stories-crawling-switch-track"
							label="Crawl status"
							checked={enabled}
							disabled
						/>
					</span>
				</Tooltip>
				{loading && <Loader size={16} />}
			</div>
		</BssoPermissions>
	);
}

export default InstagramStoryCrawlingSwitch;
